import type { Translate } from 'next-translate';

import { arrayToMap } from '~/common/utils/arrayToMap';
import { useEntitiesStore } from '~/domains/market/state/entities.store';
import { useMarketSettingsStore } from '~/domains/market/state/marketSettings.store';
import { getApiErrorMessage } from '~/domains/market/utils/getApiErrorMessage';

import type { PositionsResponse } from '../services/interfaces/positions.types';

import { transformPositions } from './positions.normalization';
import { usePositionsStore } from './positions.store';

export const syncPositionsLoading = (isLoading: boolean) => {
  usePositionsStore.getState().setLoading(isLoading);
};

export const syncPositionsData = (data: PositionsResponse, t: Translate, isFirstPage = true) => {
  const { events, teams, entities, sub_categories: subCategories } = data.included;

  // Merge entities into the unified EntitiesStore
  useEntitiesStore.getState().mergeEntities(events, teams, entities, subCategories);

  // Get current price format
  const priceFormat = useMarketSettingsStore.getState().priceFormat;

  // Transform positions
  const eventsById = arrayToMap(events);
  const teamsById = arrayToMap(teams);
  const normalizedPositions = transformPositions(data.data, eventsById, teamsById, priceFormat, t);

  // Sync positions data to PositionsStore
  usePositionsStore.getState().setPositions(data.data, normalizedPositions, isFirstPage);
};

export const syncPositionsError = (error: Error) => {
  const message = getApiErrorMessage(error);
  usePositionsStore.getState().setError(new Error(message));
};
